<template>
    <div>
            <!-- :title="`${info.company_name}明细`" -->
       <el-dialog
            top="5vh"
            width="80%"
            custom-class="dialogRadius"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="isVisible"
            :before-close="close">

            <div class="header" slot="title">
                {{info.company_name}}
            </div>

            <div class="tab flex">
                <div class="tab-item" :class="{active: activeName === 'detail'}" @click="tabClick('detail')">
                    桩群明细
                </div>
                <div class="tab-item" :class="{active: activeName === 'order'}" @click="tabClick('order')">
                    订单记录
                </div>
            </div>

            <div v-if="activeName === 'detail'">
                <el-row>
                    <el-col :span="8">
                        <query
                            :formData="formData"
                            :formList="formList"
                            @reset="resetQuery"
                            @query="query"
                            @clear="query">
                        </query>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" size="small" @click="goPrint">打印</el-button>
                    </el-col>
                </el-row>

                <el-row class="tableArea">
                    <el-col :span="24">
                        <el-table :data="tableData" class="table-border" ref="table" height="500">
                            <el-table-column type="index" label="序号" align="center"></el-table-column>
                            <el-table-column label="桩群名称" prop="pile_group_name" align="center"></el-table-column>
                            <el-table-column label="桩群地址" prop="pile_group_addrs" align="center"></el-table-column>
                            <el-table-column label="电桩数量" prop="pile_counts" align="center"></el-table-column>
                            <el-table-column label="总电量(kWh)" prop="p_power" align="center"></el-table-column>
                            <el-table-column label="结算单价" prop="fee_val" align="center"></el-table-column>
                            <el-table-column label="结算金额" prop="fee" align="center"></el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-link type="primary" :underline="false" @click="openPileDetail(scope.row)">查看</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>

                <el-row class="pageFoot">
                    <el-col :span="12">
                        <div class="statistical">
                            统计：电桩总数（{{stationTotal}}）
                            &nbsp;&nbsp;&nbsp;&nbsp;总耗电量（{{electricTotal}} kWh）
                            &nbsp;&nbsp;&nbsp;&nbsp;总结算金额（{{amountTotal}} 元）
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-pagination
                        layout="total, prev, pager, next"
                        background
                        :page-size="size"
                        :total="total"
                        @current-change="changePage">
                        </el-pagination>
                    </el-col>
                </el-row>
            </div>

            <div v-if="activeName === 'order'">
                <el-form :inline="true" size="small">
                    <el-form-item label="订单号：">
                        <el-input v-model="orderForm.query_columns.order_no" placeholder="请输入订单号：" clearable @change="getOrder('query')"></el-input>
                    </el-form-item>
                    <el-form-item label="电桩编号：">
                        <el-input v-model="orderForm.query_columns.pile_code" placeholder="请输入电桩编号：" clearable @change="getOrder('query')"></el-input>
                    </el-form-item>
                    <el-form-item label="桩群名称：">
                        <el-select v-model="orderForm.query_columns.pg_id" placeholder="请选择" clearable @change="getOrder('query')">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="(item, index) in allStation" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getOrder('query')">查询</el-button>
                        <el-button @click="resetOrder">重置</el-button>
                    </el-form-item>
                </el-form>

                <el-table :data="orderData" height="500">
                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                    <el-table-column label="订单号" prop="order_id"></el-table-column>
                    <el-table-column label="桩群名称" prop="pipe_group_name"></el-table-column>
                    <el-table-column label="电桩编号" prop="pipe_code" align="center" width="120"></el-table-column>
                    <!-- <el-table-column label="桩群地址" prop="pile_group_addrs" align="center"></el-table-column> -->
                    <el-table-column  label="充电时间">
                        <template slot-scope="scope">
                            {{calcTime(scope.row)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="充电时长" prop="p_minutes" align="center"></el-table-column>

                    <!-- <el-table-column label="电桩数量" prop="pile_counts" align="center"></el-table-column> -->
                    <el-table-column label="用电量(kWh)" prop="p_powers" align="center" width="120"></el-table-column>
                    <el-table-column label="电费" prop="fee" align="center" width="100"></el-table-column>

                    <el-table-column label="结算单价" prop="fee_val" align="center" width="100"></el-table-column>
                    <el-table-column label="结算金额" prop="fee" align="center" width="100"></el-table-column>
                    <!-- <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary" :underline="false" @click="openPileDetail(scope.row)">查看</el-link>
                        </template>
                    </el-table-column> -->
                </el-table>

                <div class="pageFoot flex">
                    <div class="tongji">
                        统计：订单数（{{orderTotal}}）&nbsp;用电量（{{orderFoot.power_fee}}kwh）&nbsp;电费（{{orderFoot.powers}}）&nbsp;服务费（{{orderFoot.service_fee}}）
                    </div>
                    <el-pagination
                        layout="total, prev, pager, next, sizes"
                        background
                        :page-size="orderForm.size"
                        :total="orderTotal"
                        :page-sizes="[20,50,100,200,500,1000]"
                        @size-change="orderSizeChange"
                        @current-change="orderPageChange">
                    </el-pagination>
                </div>
            </div>

            <!-- 电桩明细 -->
            <el-dialog
                top="5vh"
                width="80%"
                custom-class="pileDetail"
                :title="pileDetailTitle"
                :visible.sync="pileShow"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :before-close="closePileDetail"
                append-to-body>

                <el-form :inline="true" size="small">
                    <el-form-item label="电桩编号：">
                        <el-input v-model="pileDetailForm.query_columns.pile_code" placeholder="请输入电桩编号" clearable @change="getPileDetail('query')"></el-input>
                    </el-form-item>
                    <input type="text" hidden>
                    <el-form-item>
                        <el-button type="primary" @click="getPileDetail('query')">查询</el-button>
                        <el-button type="primary" @click="resetPileForm">重置</el-button>
                    </el-form-item>
                </el-form>

                <el-table :data="pileDetailData" height="500">
                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                    <el-table-column label="电桩编号" prop="pipe_code" align="center"></el-table-column>
                    <el-table-column label="总电量(kWh)" prop="p_power" align="center"></el-table-column>
                    <el-table-column label="结算单价" prop="fee_val" align="center"></el-table-column>
                    <el-table-column label="结算金额" prop="fee" align="center"></el-table-column>
                </el-table>

                <div class="pageFoot flex">
                    <div class="tongji">
                        统计：电桩总数（{{pileDetailFoot.pile_counts}}）
                            &nbsp;&nbsp;&nbsp;&nbsp;总耗电量（{{pileDetailFoot.money_counts}} kWh）
                            &nbsp;&nbsp;&nbsp;&nbsp;总结算金额（{{pileDetailFoot.power_counts}} 元）
                    </div>
                    <el-pagination
                        layout="total, prev, pager, next, sizes"
                        background
                        :page-size="pileDetailForm.size"
                        :total="pileDetailTotal"
                        :page-sizes="[20,50,100,200,500,1000]"
                        @size-change="pileDetaiSizeChange"
                        @current-change="pileDetaiPageChange">
                    </el-pagination>
                </div>

            </el-dialog>
        </el-dialog> 
    </div>
</template>
<script>
import Query from "components/query.vue";
export default {
    data() {
        return {
            activeName: 'detail',
            size: 10,
            page: 1,
            total: 0,
            stationTotal: '', // 电桩总数
            electricTotal: '', // 总耗电量
            amountTotal: '', // 总结算金额
            formData: {
                pg_id: ''
            },
            formList: [
                {
                    type: "select",
                    label: "桩群名称：",
                    placeholder: "请选择桩群",
                    model: "pg_id",
                    labelName: 'name',
                    valueName: 'id',
                    optionList: []
                }
            ],
            tableData: [],
            allStation: [],

            // 电桩明细
            pileShow: false,
            pileDetailTitle: '',
            pileDetailTotal: 0,
            pileDetailForm: {
                page: 1,
                size: 20,
                query_columns: {
                    cid: '',
                    pg_id: '',
                    start_time: '',
                    end_time: '',
                    pile_code: '',
                }
            },
            pileDetailData: [],
            pileDetailFoot: {
                pile_counts: '', //电桩
                money_counts: '', //总金额
                power_counts: '', //总电量
            },

            // 订单
            orderForm:{
                page: 1,
                size: 20,
                query_columns:{
                    pg_id: '', //桩群id
                    p_id: '', //电桩id
                    id: '', //桩群数据id
                    order_no: '',
                    pile_code: '',
                    company_id: '', //厂商id
                    phone: '',
                    start_time: '',
                    end_time: '',
                    status: '',
                }
            },
            orderTotal: 0,
            orderData: [],
            orderFoot: {
                counts: 0,
                power_fee: 0,
                powers: "",
                service_fee: 0,
            },
        }
    },
    props:{
        info: Object,
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    components:{
        Query
    },
    created() {
        this.init();
        this.pileDetailForm.query_columns.cid = this.info.company_id;
        this.pileDetailForm.query_columns.pg_id = this.formData.pg_id;
        this.pileDetailForm.query_columns.start_time = this.info.start_time;
        this.pileDetailForm.query_columns.end_time = this.info.end_time;

        this.orderForm.query_columns.company_id = this.info.company_id;
    },
    methods: {
        init(){
            this.getTableList();
            this.getStationGroup();
            this.getOrder();
        },
        getTableList(){
            let params = {
                page: this.page,
                size: this.size,
                query_columns: {
                    cid: this.info.company_id,
                    pg_id: this.formData.pg_id,
                    company_name: '',
                    company_mobile: '',
                    start_time: this.info.start_time,
                    end_time: this.info.end_time
                }   
            };
            this.$http.post(this.common.admin + "/api/reconciliationListGp", params).then((res) => {
                if (res.code === 200) {
                    this.total = res.data.count;
                    this.tableData = res.data.list;
                    this.stationTotal = res.data.statistics.piles.value;
                    this.electricTotal = res.data.statistics.power.value;
                    this.amountTotal = res.data.statistics.fee.value;
                } else {
                    return this.$message.error(res.msg);
                }
            });
        },
        // 获取桩群信息
        getStationGroup(){
            this.$http.get(this.common.admin + '/admin/pileGroupAllList',{
                params: {
                    company_id: this.info.company_id
                }
            }).then(res => {
                if(res.code === 200){
                this.allStation = res.data;
                    for(let i of this.formList){
                        if(i.label === '桩群名称：'){
                            i.optionList = res.data;
                        }
                    }
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        // 获取订单信息
        getOrder(type){
            if(type === 'query'){
                this.orderForm.page = 1;
            }
            this.$http.post(this.common.admin + '/api/getRechargeList', this.orderForm).then(res => {
                if(res.code === 200){
                    this.orderData = res.data.list;
                    this.orderTotal = res.data.count;
                    if(res.data.list.length != 0){
                        this.orderFoot = res.data.statistic;
                    }else{
                        this.orderFoot = {
                            counts: 0,
                            power_fee: 0,
                            powers: "",
                            service_fee: 0,
                        }
                    }
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        resetOrder(){
            this.orderForm = {
                page: 1,
                size: 20,
                query_columns:{
                    pg_id: '', //桩群id
                    p_id: '', //电桩id
                    id: '', //桩群数据id
                    order_no: '',
                    pile_code: '',
                    company_id: '', //厂商id
                    phone: '',
                    start_time: '',
                    end_time: '',
                    status: '',
                }
            };

            this.getOrder();
        },
        calcTime(data){
            let time = '';
            if(data.end_time == 0){
                time = '';
            }else{
                time = this.formatTime(data.start_time)+' ~ '+this.formatTime(data.end_time);
            }
            return time;
        },
        formatTime(val){
            var time = new Date(val*1000);
            var year = time.getFullYear();
            var month = time.getMonth()+1;
            var day = time.getDate();
            var hour = time.getHours();
            var minute = time.getMinutes();
            var second = time.getSeconds();
            return year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day)+' '+(hour<10?'0'+hour:hour)+':'+(minute<10?'0'+minute:minute)+':'+(second<10?'0'+second:second)
        },
        currentTime(){
            var time = new Date();
            var year = time.getFullYear();
            var month = time.getMonth()+1;
            var day = time.getDate();
            return year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day);
        },
        orderSizeChange(val){
            this.orderForm.size = val;
            this.getOrder('query');
        },
        orderPageChange(val){
            this.orderForm.page = val;
            this.getOrder();
        },
        resetQuery(){
            this.formData = {
                pg_id: ''
            };
            this.getTableList();
        },
        query(){
            this.getTableList();
        },
        changePage(page){
            this.page = page;
            this.getTableList();
        },
        close(){
            this.$emit('close');
        },
        
        // 打印
        goPrint(){
            let routeData = this.$router.resolve({
                path: "/printDetail",
                query: {
                    name: this.info.company_name,
                    cid: this.info.company_id,
                    start: this.info.start_time,
                    end: this.info.end_time,
                },
            });
            window.open(routeData.href, '_blank');
        },
        // 切换选项卡
        tabClick(type){
            this.activeName = type;
        },
        // 打开桩明细
        openPileDetail(data){
            this.pileShow = true;
            this.pileDetailTitle = data.pile_group_name;
            this.getPileDetail();
        },
        closePileDetail(){
            this.pileShow = false;
            this.getPileDetail();
        },
        getPileDetail(type){
            if(type === 'query'){
                this.pileDetailForm.page = 1;
            }
            this.$http.post(this.common.admin + '/api/pileStatistic', this.pileDetailForm).then(res => {
                if(res.code === 200){
                    this.pileDetailData = res.data.list;
                    this.pileDetailTotal = res.data.count;
                    this.pileDetailFoot.pile_counts = res.data.statistics.pile_counts.value;
                    this.pileDetailFoot.money_counts = res.data.statistics.money_counts.value;
                    this.pileDetailFoot.power_counts = res.data.statistics.power_counts.value;

                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        resetPileForm(){
            this.pileDetailForm = {
                page: 1,
                size: 20,
                query_columns: {
                    cid: this.info.company_id,
                    pg_id: this.formData.pg_id,
                    start_time: this.info.start_time,
                    end_time: this.info.end_time,
                    pile_code: '',
                }
            };
            this.getPileDetail();
        },
        pileDetaiSizeChange(val){
            this.pileDetailForm.size = val;
            this.getPileDetail('query');
        },
        pileDetaiPageChange(val){
            this.pileDetailForm.page = val;
            this.getPileDetail();
        },
    },
}
</script>
<style lang="less" scoped>
    /deep/.innerDialog{
        min-height: 800px;
        .table{
            padding-bottom: 26px;
            .table-head{
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;
                .title{
                    font-size: 24px;
                    font-weight: 500;
                    color: #161616;
                }
            }
        }
        
    }
    /deep/.dialogRadius{
        .el-dialog__header{
            padding-bottom: 0;
        }
        .header{
            font-size: 24px;
            color: #161616;
        }
        .tab{
            margin-bottom: 30px;
            border-bottom: 1px solid #ebeef5;
            align-items: center;

            .tab-item{
                padding: 15px 0;
                margin-right: 30px;
                border-bottom: 2px solid transparent;
                color: #161616;
                font-size: 20px;
                cursor: pointer;

                &.active,
                &:hover{
                    color: var(--main-theme-color);
                    border-color: var(--main-theme-color);
                }
            }
        }

        .pageFoot{
            align-items: center;
            justify-content: space-between;
            .tongji{
                font-size: 14px;
            }
        }
    }
    /deep/.pileDetail{
        .pageFoot{
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tongji{
                font-size: 14px;
            }
        }
    }
    .print-head{
            text-align: center;
            font-size: 24px;
            padding: 15px 0;
            color: #161616;
        }
    .print{
        // border: 1px solid #ebeef5;
        color: #161616;
        /deep/.el-table{
            font-size: 16px;
            border-color: #161616;
            
        }
        /deep/.el-table td.el-table__cell,
        /deep/.el-table th.el-table__cell.is-leaf{
            border-bottom: 1px solid #161616;
        }
        /deep/.el-table--border::after,
        /deep/.el-table--group::after,
        /deep/.el-table::before{
            background-color: #161616;
        }

        .underline{
            padding: 0 15px;
            border-bottom: 1px solid #161616;
        }

        
        .print-body-subtitle{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0px;
            padding-right: 0;
            font-size: 16px;
        }

        .print-body-foot{
            display: flex;
            justify-content: flex-end;
            padding: 10px 0;
            padding-right: 20px;
            font-size: 16px;
            &>div{
                margin-left: 180px;

                &:first-of-type{
                    margin-left: 0;
                }
            }
        }
    }
</style>